import React from 'react'
import { Button, Tooltip } from '@material-ui/core'
import { Upload } from 'lib/lucide'

interface UploadButtonProps {
  id: string
  accept: string
  label: React.ReactNode
  options?: Object
  onChange: (file: File, options?: Object) => void
  maxSizeInMB?: number
  withoutStartIcon?: boolean
}

const UploadButton: React.FC<UploadButtonProps> = ({
  id,
  accept,
  label,
  onChange,
  options,
  maxSizeInMB,
  withoutStartIcon,
}) => {
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    if (!e.target.files?.length) return
    const file = e.target.files[0]

    if (maxSizeInMB && file.size > maxSizeInMB * 1024 * 1024) {
      alert(`El tamaño del archivo debe ser menor a ${maxSizeInMB} MB`)
      return
    }

    const extensions = accept
      .replace(/\s/g, '') // Eliminar espacios
      .split(',') // Dividir por comas
      .map(ext => ext.replace('.', '')) // Eliminar el punto inicial de cada extensión

    const regex = new RegExp(`(${extensions.join('|')})$`, 'i')

    if (!regex.test(file.type)) {
      alert('El archivo debe ser una imagen formato JPG, JPEG o PNG')
      return
    }

    onChange(file, options)
  }

  return (
    <label htmlFor={id}>
      <input
        accept={accept}
        style={{ display: 'none' }}
        id={id}
        type="file"
        onChange={handleChange}
      />
      <Tooltip title={`Formatos compatibles: ${accept}`} placement="bottom">
        <Button
          variant="contained"
          color="primary"
          component="span"
          startIcon={withoutStartIcon ? undefined : <Upload size={18} />}
        >
          {label}
        </Button>
      </Tooltip>
    </label>
  )
}

export { UploadButton }
